import { defineMessages } from 'react-intl';

export const navigationMessages = defineMessages({
  expandBrowse: {
    id: 'navigation.expandBrowse',
    defaultMessage: 'Expand browse links',
  },
  collapseBrowse: {
    id: 'navigation.collapseBrowse',
    defaultMessage: 'Collapse browse links',
  },
  expandDashboard: {
    id: 'navigation.expandDashboard',
    defaultMessage: 'Expand dashboard links',
  },
  collapseDashboard: {
    id: 'navigation.collapseDashboard',
    defaultMessage: 'Collapse dashboard links',
  },
  browse: {
    id: 'navigation.browse',
    defaultMessage: 'Browse',
  },
  dashboard: {
    id: 'navigation.dashboard',
    defaultMessage: 'My dashboard',
  },
});
